import dayjs from "dayjs";
import type { OSADShipments } from "../../types/operations/osad.type";

export const osadSummaryAndShipments = {
  default: {
    summary: {
      areaName: "OSAD",
      bills: 4,
      pieces: 2,
      pallets: 2,
      weight: 3322,
      handlingUnits: 3,
      billsByTags: [
        {
          id: 2,
          name: "UC",
          color: "#FBC02D",
          colorHex: "#FBC02D",
          bills: 1,
          position: 20,
        },
        {
          id: 81,
          name: "VC",
          color: "#AA7EA0",
          colorHex: "#AA7EA0",
          bills: 1,
          position: 40,
        },
        {
          id: 6,
          name: "LG",
          color: "#679CB2",
          colorHex: "#679CB2",
          bills: 2,
          position: 50,
        },
        {
          id: 75,
          name: "OVL",
          color: "#C77563",
          colorHex: "#C77563",
          bills: 2,
          position: 80,
        },
        {
          id: 5,
          name: "APTM",
          color: "#69ADA8",
          colorHex: "#69ADA8",
          bills: 1,
          position: 110,
        },
        {
          id: 4,
          name: "APTR",
          color: "#777DE9",
          colorHex: "#777DE9",
          bills: 1,
          position: 120,
        },
        {
          id: 9,
          name: "DTCL",
          color: "#5E9FE0",
          colorHex: "#5E9FE0",
          bills: 1,
          position: 190,
        },
      ],
    },
    shipments: [
      {
        shipmentId: 135280698,
        proNumber: "160160594",
        reasonId: 79,
        reasonCode: "All Short",
        pallets: 1,
        pieces: 2,
        weight: 1210,
        weightUnit: "lbs",
        handlingUnits: 3,
        tags: [
          {
            id: 5,
            name: "APTM",
            description: "",
            color: "#69ADA8",
            colorHex: "#69ADA8",
            position: 110,
            bills: 1,
          },
        ],
        originSic: "HTX",
        destinationSic: "TEB",
        destinationSicCode: "EWR",
        finalDestinationSic: "PHL",
        status: "CLDK",
        dueServiceDate: dayjs("2026-11-03").toDate(),
        serviceDueDate: dayjs("2026-11-03").toDate(),
        appointmentDate: dayjs("2026-11-03").toDate(),
        appointmentEndDate: dayjs("2026-11-03").toDate(),
        appointmentStartTimestampUtc: dayjs("2026-11-03").toDate(),
        appointmentEndTimestampUtc: dayjs("2026-11-03").toDate(),
        careOfDelivery: null,
        consignee: null,
        deliveryAddress: null,
        loadToSicId: 1,
        loadTo: "PHL",
        currentLocation: {
          type: "OSAD",
          name: "On OSAD",
          trailer: "DAL-1234",
          pullId: 891027,
          trapId: 160160594,
          tripNumber: 1,
        },
        isPlannedOB: false,
        isPlannedIB: true,
        futurePlanDates: [],
        futurePlannedDate: 0,
      },
      {
        shipmentId: 135953125,
        proNumber: "181656133",
        reasonId: 79,
        reasonCode: "Other",
        pallets: 1,
        pieces: 0,
        weight: 270,
        weightUnit: "lbs",
        handlingUnits: 0,
        tags: [
          {
            id: 6,
            name: "LG",
            description: "",
            color: "#679CB2",
            colorHex: "#679CB2",
            position: 50,
            bills: 2,
          },
          {
            id: 4,
            name: "APTR",
            description: "",
            color: "#777DE9",
            colorHex: "#777DE9",
            position: 120,
            bills: 1,
          },
          {
            id: 9,
            name: "DTCL",
            description: "",
            color: "#5E9FE0",
            colorHex: "#5E9FE0",
            position: 190,
            bills: 1,
          },
        ],
        originSic: "ONT",
        destinationSic: "EWR",
        finalDestinationSic: "EWR",
        status: "UNLD",
        dueServiceDate: dayjs("2026-02-03").toDate(),
        serviceDueDate: dayjs("2026-02-03").toDate(),
        appointmentDate: null,
        appointmentEndDate: null,
        destinationSicCode: "EWR",
        loadToSicId: 1,
        loadTo: "EWR",
        currentLocation: {
          type: "OSAD",
          name: "On OSAD",
          trailer: null,
          pullId: null,
          trapId: null,
          tripNumber: null,
        },
        careOfDelivery: null,
        consignee: null,
        deliveryAddress: null,
        isPlannedOB: true,
        isPlannedIB: false,
        futurePlanDates: [],
        futurePlannedDate: 0,
      },
      {
        shipmentId: 135273782,
        proNumber: "169321874",
        reasonId: 79,
        reasonCode: "All Short",
        pallets: 2,
        pieces: 0,
        weight: 1352,
        weightUnit: "lbs",
        handlingUnits: 0,
        tags: [
          {
            id: 75,
            name: "OVL",
            description: "",
            color: "#C77563",
            colorHex: "#C77563",
            position: 80,
            bills: 2,
          },
        ],
        originSic: "VIS",
        destinationSic: "DAL",
        finalDestinationSic: "DAL",
        status: "UNLD",
        dueServiceDate: dayjs("2025-11-03").toDate(),
        serviceDueDate: dayjs("2025-11-03").toDate(),
        appointmentDate: null,
        appointmentEndDate: null,
        destinationSicCode: "DAL",
        loadToSicId: 114,
        loadTo: "DAL",
        currentLocation: {
          type: "OSAD",
          name: "On OSAD",
          trailer: null,
          pullId: null,
          trapId: null,
          tripNumber: null,
        },
        careOfDelivery: null,
        consignee: null,
        deliveryAddress: null,
        isPlannedOB: false,
        isPlannedIB: false,
        futurePlanDates: [],
        futurePlannedDate: 0,
      },
      {
        shipmentId: 135282167,
        proNumber: "160158036",
        reasonId: 79,
        reasonCode: "All Short",
        pallets: 1,
        pieces: 0,
        weight: 490,
        weightUnit: "lbs",
        handlingUnits: 0,
        tags: [
          {
            id: 75,
            name: "OVL",
            description: "",
            color: "#C77563",
            colorHex: "#C77563",
            position: 80,
            bills: 2,
          },
        ],
        originSic: "ONT",
        destinationSic: "DAL",
        finalDestinationSic: "DAL",
        status: "UNLD",
        dueServiceDate: dayjs("2025-11-03").toDate(),
        serviceDueDate: dayjs("2025-11-03").toDate(),
        appointmentDate: null,
        appointmentEndDate: null,
        destinationSicCode: "DAL",
        loadToSicId: 114,
        loadTo: "DAL",
        currentLocation: {
          type: "OSAD",
          name: "On OSAD",
          trailer: null,
          pullId: null,
          trapId: null,
          tripNumber: null,
        },
        careOfDelivery: null,
        consignee: null,
        deliveryAddress: null,
        isPlannedOB: false,
        isPlannedIB: false,
        futurePlanDates: [],
        futurePlannedDate: 0,
      },
    ],
  },
} as const satisfies Record<string, OSADShipments>;
